import { render, staticRenderFns } from "./productGuidePrice.vue?vue&type=template&id=3caec55c"
import script from "./productGuidePrice.vue?vue&type=script&lang=js"
export * from "./productGuidePrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports